import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'NEW_POST';

export const {
    action: initialFetch,
    success: initialFetchSuccess,
    failed: initialFetchFailed,
} = createAction(`${domain}/INITIAL_FETCH`, (recipientsType, context, initialValues) => ({
    recipientsType,
    context,
    initialValues,
}));

export const {action: changeFrom} = createAction(
    `${domain}/CHANGE_FROM`,
    (form, newSender, currentRecipients, type, extraData) => ({form, newSender, currentRecipients, type, extraData}),
);

export const {
    action: searchChildren,
    success: searchChildrenSuccess,
    failed: searchChildrenFailed,
    aborted: searchChildrenAborted,
} = createAction(`${domain}/SEARCH`, (term, institutionIds) => ({term, institutionIds}));

export const {action: addEYFSLinks} = createAction(`${domain}/ADD_EYFS_LINKS`, (formIdentifier, refinements) => ({
    formIdentifier,
    refinements,
}));
